import { BROACAST_SOURCES_SELECT_TAB } from 'actions/Types';

const currentTab = 'speakers';
export const initialState = {
  currentTab
};

export default (state = initialState, action) => {
  if (action.type === BROACAST_SOURCES_SELECT_TAB)
    return { ...initialState, currentTab: action.payload };

  return state;
};
